export * from './dealer/budget-interface.model';
export * from './dealer/quotation.model';
export * from './dealer/service.model';
export * from './language/language.model';
export * from './recall/closed-recall.model';
export * from './recall/recall-history';
export * from './recall/recall-part';
export * from './res/response.model';
export * from './revision/revision-history.model';
export * from './revision/revision-part-vo.model';
export * from './revision/revision-part.model';
export * from './revision/revision.model';
export * from './schedule/schedule-details.model';
export * from './schedule/schedule-history.model';

// TODO: ESSES MODELOS ESTÃO ERRADO DEVEM SER DISTRIBUIDOS POR PASTAS E NÃO POR PROJETOS